<template lang="pug">
  .container
    .header
      img.banner(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/top_bg3.png")
      el-form.mobile-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入陕西移动手机号")
        el-form-item(v-if="isCheckMobile")
          el-row
            el-col(:span="13")
              el-input(type="text", placeholder="请输入短信验证码", v-model="form.verifyCode", maxlength="6")
            el-col(:span="9", :offset="1")
              el-button(type="warning", :disabled="leftSendTime > 0", @click="sendVerifyCode")
                span(v-if="leftSendTime <= 0") 获取验证码
                span(v-else) {{leftSendTime}}秒后可重试
      //- .share-ad
      //-   img(@click="shareNoticeVisiable = true", src="../../assets/images/shaanxi/sharebanner.png")
      //-   div 点击上方图片领取100元红包
    .bottom
      el-button(v-if="!isCheckMobile", type="warning", @click="checkMobile") 限时领取
      el-button(v-else, type="warning", @click="handleSubmit") 确定办理
    .img-desc
      img(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/info3.png")
    .img-desc
      img(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/info2.png")
    .notice
      ul
        li(v-for="(notice, index) in notices", :key="index")
          .num {{index + 1}}.
          p.content {{notice}}
    el-dialog(
      width="80%",
      title="提示",
      :visible.sync="dialogVisible",
      :before-close="handleClose"
    )
      .dialog-content
        div
          | 您要为手机号：
          span.mobile-info {{form.mobile}}
        div
          | 办理业务：
          span.package-info {{selectedPackage.name}}
      span.dialog-footer(slot="footer")
        el-button(@click="dialogVisible = false") 取消
        el-button(type="primary", @click="handleSubmit") 确定
    .share-dialog(v-if="shareNoticeVisiable", @click="shareNoticeVisiable = false")
      img(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/share-dialog.png")
</template>

<script>

// 推啊=TUIA、豆盟=DOUMENG、快手=KUAISHOU
export default {
  data() {
    return {
      errlog: '',
      shareNoticeVisiable: false,
      showMoreNotice: false,
      dialogVisible: false,
      leftSendTime: 0,
      isCheckMobile: false,
      channel: 'WX_MP',
      form: {
        carrierId: 1,
        mobile: '',
        verifyCode: '',
        userId: null,
        sharerId: null
      },
      notices: [
        '本活动仅限陕西移动用户参加，免费体验1个月。包含：1个月会员，20GB定向流量，订购立即生效。',
        '成功办理本业务后扣除30元话费，然后立即返还30元话费进您的主账户，不可冲抵梦网信息费及代收费。',
        '本产品原价60元，限时福利免费体验1个月，之后每月享5折优惠，每月扣除30元。',
        '会员获取：客户成功办理之后，每月可领取一次月会员（视频APP、音乐APP和阅读APP等共20款热门会员任选1种），可通过短信链接领取。领取会员为月会员，若优惠包不退订可每月领取一次（需当月领取过期作废），会员领取后24小时内生效；若用户退订了相关优惠包，则次月不再享有视频会员领取资格。',
        '产品内所含20GB定向流量可适用于腾讯视频、优酷、爱奇艺、芒果TV、网易云音乐、酷我音乐、喜马拉雅、咪咕视频、咪咕阅读、咪咕音乐、快手、西瓜视频、今日头条、火山和抖音APP。',
        '该流量包为连续包月，首月不可退订，办理退订后次月生效（如因合作方资源限制等原因无法提供会员服务，我方会立即停止收取该产品费用并暂停会员服务）。',
        '优惠包内所含的流量均为定向流量，在指定期限内有效，流量不可转增，不可分享，不可结转，超过有效期自动清零。'
      ],
      selectedPackage: {},
      packageList: [
        {
          goodsCode: 'WXMP01600003',
          name: '20GB定向流量+视频会员',
          desc: '30元/月 首月免单',
          tips: [
            '20GB互联网产品定向流量任性用，100条国内短信（不包含港澳台）；',
            '互联网会员20选1（爱奇艺、优酷、腾讯、芒果、喜马拉雅等），月月主动领，次月可更换'
          ]
        }
        // {
        //   goodsCode: 'WXMP01600002',
        //   name: '10GB定向流量+视频会员',
        //   desc: '20元/月 首月免单',
        //   tips: [
        //     '10GB互联网产品定向流量任性用，100条国内短信（不包含港澳台）；',
        //     '互联网会员20选1（爱奇艺、优酷、腾讯、芒果、喜马拉雅等），月月主动领，次月可更换'
        //   ]
        // }
      ]
    }
  },
  mounted() {
    this.handleSelected(this.packageList[0])
  },
  methods: {
    handleSelected(selectedPackage) {
      this.selectedPackage = selectedPackage
    },
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    showConfirm() {
      this.dialogVisible = true
    },
    checkMobile() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.selectedPackage.goodsCode,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.isCheckMobile = true
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.selectedPackage.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            if (this.form.userId) {
              this.$router.push({
                name: 'videoflowbagSuccess'
              })
            } else {
              this.$router.push({
                name: 'commonSuccessShowAD'
              })
            }
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scope>
.container{
  background-color: rgb(65, 201, 154);
  padding-bottom: 3.5rem;
}
.header{
  .banner{
    width: 100%;
  }
}
.module-bg{
  width: 90%;
  margin: 0 auto;
  border: 2px solid #48c89f;
  border-radius: 6px;
  padding: 6px;
  background-color: #ffffff;
}
.mobile-form{
  padding: 0 48px;
  margin-top: -140px;
}
.packages-form{
  .packages-info{
    >ul{
      display: flex;
      >li{
        flex: 1;
        font-size: .8rem;
        font-weight: bold;
        background-color: #f5f3f3;
        margin: .4rem;
        border-radius: 12px;
        >div{
          margin: .8rem .2rem;
        }
        .name{
          color: #e69a79;
        }
        .desc{
          color: #888;
        }
        &.selected{
          background-color: #88f3d1;
          .name{
            color: #e75e25;
          }
          .desc{
            color: #333;
          }
        }
      }
    }
    .tips{
      margin: 6px;
      font-size: .8rem;
      text-align: left;
      .tip{
        margin: 3px 0;
        i{
          color: #48c89f;
        }
      }
    }
  }
}
.user-notice{
  margin-top: 12px;
  font-size: .8rem;
  color: #222;
  .title{
    color: #48c89f;
    font-size: 1rem;
  }
  .content{
    text-align: left;
    margin: 6px;
    ul{
      margin-left: .4rem;
    }
  }
}
.dialog-content{
  text-align: left;
  .mobile-info{
    color: #333;
    font-weight: bold;
  }
  .package-info{
    color: #e75e25;
    font-weight: bold;
  }
}
.share-ad{
  text-align: center;
  color: #a3a3a3;
  font-size: .9rem;
  img{
    width: 94%;
  }
}
.share-dialog{
  position: fixed;
  z-index: 10;
  top: 0px;
  right: 0px;
  background-color: rgba(0,0,0,.8);
  width: 100%;
  height: 900px;
}
.bottom{
  width: 70%;
  // z-index: 9;
  // position: fixed;
  // bottom: 0;
  margin: 0 auto;
  margin-top: 1rem;
  height: 2.9rem;
  button{
    width: 100%;
    border-radius: 0;
    font-size: 1.3rem;
    border-radius: 36px;
    box-shadow: 0 3px 3px #a3a3a3;
  }
}
.share-infos{
  color: #a3a3a3;
  font-size: .5rem;
}
.img-desc{
  margin: 0 1.2rem;
  margin-top: 2.6rem;
  img{
    width: 100%;
  }
}
.notice{
  position: relative;
  &:after{
    position: absolute;
    background: url('https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/title.png') no-repeat;
    background-size: 100%;
    content: '';
    width: 14rem;
    height: 4rem;
    left: 50%;
    top: -1.1rem;
    margin-left: -7rem;
  }
  background-color: #fff;
  border-radius: .4rem;
  text-align: left;
  padding: 1.5rem .8rem .6rem;
  margin: 0 1.2rem;
  margin-top: 2.6rem;
  font: "黑体", "Arial";
  ul{
    margin-top: 1rem;
    li{
      clear: both;
      overflow: hidden;
      font-size: .8rem;
      color: #4A9F94;
      margin-bottom: .2rem;
      .num{
        float: left;
        width: 1.4rem;
        line-height: 1.2rem;
      }
      .content{
        line-height: 1.2rem;
        margin-left: 1.3rem;

      }
    }
  }
}
.el-form-item {
  margin-bottom: .4rem;
}
</style>